// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cxGdxlas3ShzNOB06M3P {
  background-color: #dce7f4;
  padding: 0px 28px;
  height: 24px;
  display: flex;
  align-items: center;
}
.cxGdxlas3ShzNOB06M3P ol {
  list-style: none;
  display: flex;
  padding: 0;
  align-items: center;
  gap: 10px;
}

.HnfPE8RP5AimhQmWmGyr {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.HnfPE8RP5AimhQmWmGyr a {
  text-decoration: none;
  color: #2d73b9;
}
.HnfPE8RP5AimhQmWmGyr a:hover {
  text-decoration: underline;
}
.HnfPE8RP5AimhQmWmGyr.gxPt3h7xtzKSrhd_KtQg a {
  color: #3f3f46;
  text-decoration: none;
  pointer-events: none;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./packages/common/utils/components/src/lib/Breadcrumb/Breadcrumb.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAGA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACE,qBAAA;EACA,cAAA;AAAJ;AAEI;EACE,0BAAA;AAAN;AAIE;EACE,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;AAFJ","sourceRoot":""}]);
// Exports
export var breadcrumb = `cxGdxlas3ShzNOB06M3P`;
var _1 = `HnfPE8RP5AimhQmWmGyr`;
export { _1 as "breadcrumb-item" };
export var active = `gxPt3h7xtzKSrhd_KtQg`;
export default ___CSS_LOADER_EXPORT___;
